import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"

// Connects to data-controller="autosave-textarea"
export default class extends Controller {
  static targets = ["formular"]

  connect() {
    this.formData = new FormData(this.formularTarget);
    
    // Setze url '/executive_summarys/:id/autosave', to: 'executive_summarys#autosave', as: 'autosave_executive_summary'
    // Setze url '/bemerkungs/:id/autosave', to: 'bemerkungs#autosave', as: 'autosave_bemerkung'
    this.url = this.formularTarget.action + "/autosave";
    
    // Delay in ms fuer das autosaving
    this.autosaveDelay = 1000;

    const requestToDelay = () => this.sendRequest(this.url, this.formData);

    // Debounce the request to avoid sending too many requests.
    // The request will be sent after the time specified in autosaveDelay
    // has passed since the last call to the debounced function.
    this.debouncedRequest = _.debounce(requestToDelay, this.autosaveDelay);
  }

  save() {
    this.formData = new FormData(this.formularTarget);
    // Call the debounced request with the new form data.
    this.debouncedRequest(this.url, this.formData);
  }

  sendRequest(url, formData) {
    patch(url, { responseKind: "turbo-stream", body: formData })
  }
}
